export function updateShaftCount(draft, shaftCount) {
  let oldLength = draft.tieup.length;
  draft.tieup.length = shaftCount;
  draft.tieup.fill([], oldLength);
  draft.shaftCount = shaftCount;
}

export function updateTreadleCount(draft, treadleCount) {
  draft.tieup.forEach((t) => {
    let oldLength = t.length;
    t.length = treadleCount;
    t.fill(0, oldLength);
  });
  draft.treadleCount = treadleCount;
}

export function updateWarpCount(draft, warpCount) {
  let amountToAdd = warpCount - draft.warpCount;
  if (amountToAdd === 0) {
    return draft;
  }
  draft.warpCount = warpCount;
  changeArraySize(draft.warpColors, warpCount);
  changeArraySize(draft.threading, warpCount);
}

export function updateWeftCount(draft, weftCount) {
  let amountToAdd = weftCount - draft.weftCount;
  if (amountToAdd === 0) {
    return draft;
  }
  draft.weftCount = weftCount;
  changeArraySize(draft.weftColors, weftCount);
  changeArraySize(draft.treadleOrder, weftCount);
}

export function applyPattern(
  draft,
  pattern,
  warpOrWeft,
  mirroredRepeat,
  start = 0,
  end = warpOrWeft === 'warp' ? draft.warpCount : draft.weftCount
) {
  let array = draft[warpOrWeft === 'warp' ? 'threading' : 'treadleOrder'];

  let offset = 0;
  let length = Math.min(end - start, array.length - start);
  for (let i = start; i < length; i++) {
    if (mirroredRepeat && i !== 0 && i % (pattern.length - 1) === 0) {
      offset += 1;
    }
    let j = i + offset;
    let v = j % pattern.length;
    if (mirroredRepeat && Math.floor(j / pattern.length) % 2 === 1) {
      v = pattern.length - (j % pattern.length) - 1;
    }
    array[i] = pattern[v];
  }
}

export function changeArraySize(array, newSize) {
  let amountToAdd = newSize - array.length;
  if (amountToAdd > 0) {
    let originalSize = array.length;
    for (let i = 0; i < amountToAdd; i++) {
      array.push(array[i % originalSize]);
    }
  } else {
    array.splice(array.length + amountToAdd);
  }
}

export function applyColor(
  draft,
  colors,
  warpOrWeft,
  start = 0,
  length = warpOrWeft === 'warp' ? draft.warpCount : draft.weftCount
) {
  let newColors = draft[warpOrWeft === 'warp' ? 'warpColors' : 'weftColors'];
  for (let i = start; i < length; i++) {
    newColors[i] = colors[i % colors.length];
  }
}

export function removeYarn(draft, yarnToRemoveId) {
  let oldIndex = draft.yarn.findIndex((yarn) => yarn.id === yarnToRemoveId);
  let newYarnId;
  if (oldIndex === 0) {
    newYarnId = draft.yarn[1].id;
  } else {
    newYarnId = draft.yarn[oldIndex - 1].id;
  }

  draft.yarn.splice(oldIndex, 1);

  for (let i = 0; i < draft.warpColors.length; i++) {
    let yarnIndex = draft.warpColors[i];
    if (yarnIndex === yarnToRemoveId) {
      draft.warpColors[i] = newYarnId;
    }
  }
  for (let i = 0; i < draft.weftColors.length; i++) {
    let yarnIndex = draft.weftColors[i];
    if (yarnIndex === yarnToRemoveId) {
      draft.weftColors[i] = newYarnId;
    }
  }
}

export function newYarn(draft, yarn) {
  let id = draft.yarn.map((a) => a.id).reduce((a, b) => Math.max(a, b)) + 1;
  draft.yarn.push({ ...yarn, id });
}
